<script>
import micIconSrc from './icons/microphone-icon.svg'

export default {
    props: {
        value: {
            default() {
                return ''
            }
        }
    },
    data() {
        return {
            micIconSrc,
            isListening: false,
            recognition: null
        }
    },
    mounted() {
        if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
            const SpeechRecognitionConstructor = window.SpeechRecognition || window.webkitSpeechRecognition
            this.recognition = new SpeechRecognitionConstructor()

            if (this.recognition) {
                this.recognition.continuous = false
                this.recognition.lang = 'vi-VN'
                this.recognition.interimResults = false

                this.recognition.onresult = (event) => {
                    const transcript = event.results[0][0].transcript
                    this.$emit('input', this.value + transcript)
                }

                this.recognition.onerror = (event) => {
                    console.error('Speech recognition error:', event.error)
                    this.stopListening()
                }

                this.recognition.onend = () => {
                    this.isListening = false
                }
            }
        }
    },
    methods: {
        startListening() {
            if (!this.recognition) return
            try {
                this.recognition.start()
                this.isListening = true
            } catch (err) {
                console.warn('Speech recognition already started:', err)
            }
        },
        stopListening() {
            if (!this.recognition) return
            this.recognition.stop()
            this.isListening = false
        }
    },
    onBeforeUnmount() {
        this.stopListening()
    }
}
</script>

<template>
    <button type="button" @click="isListening ? stopListening() : startListening()" class="stt-button">
        <img :src="micIconSrc" class="stt-icon" :class="{ 'listening': isListening }" />
    </button>
</template>

<style scoped>
.stt-button {
    border: none;
    outline: none;
    padding: 0;
}

.stt-icon {
    width: 1.7rem;
}

.stt-icon.listening {
    filter: hue-rotate(120deg);
}
</style>